import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { employmentIssues } from '../../../constants/formFields/employmentIssues';

export const StepSix = () => {
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step">
      {/* <h6 className="text-lg font-bold mb-6">Employment issues</h6> */}

      <div className="mb-6 form-radio2-main">
        <p>
          <strong>Employment issues *</strong>
          <span>Select all that apply</span>
        </p>
        <div className="space-y-2">
          {employmentIssues?.map((ele, i) => {
            const id = `employment_issues_${i}`;
            return (
              <div className="flex items-center form-check2" key={id}>
                <Field
                  type="checkbox"
                  id={id}
                  name="employment_issues"
                  value={ele?.value}
                  className="mr-2"
                />
                <label htmlFor={id}>{ele?.label}</label>
              </div>
            );
          })}
          <ErrorMessage name="employment_issues" component="div" className="required-text" />
        </div>
      </div>
    </div>
  );
};
